import * as duckdb from "@duckdb/duckdb-wasm";

const LOCAL_BUNDLES: duckdb.DuckDBBundles = {
  mvp: {
    mainModule: `${process.env.PUBLIC_URL}/static/duckdb/duckdb-mvp.wasm`,
    mainWorker: `${process.env.PUBLIC_URL}/static/duckdb/duckdb-browser-mvp.worker.js`,
  },
  eh: {
    mainModule: `${process.env.PUBLIC_URL}/static/duckdb/duckdb-eh.wasm`,
    mainWorker: `${process.env.PUBLIC_URL}/static/duckdb/duckdb-browser-eh.worker.js`,
  },
};

const initPromise: Promise<duckdb.AsyncDuckDB> = (async () => {
  console.time("[DuckDB] 初期化合計");
  console.time("[DuckDB] バンドル選択");
  const bundle = await duckdb.selectBundle(LOCAL_BUNDLES);
  console.timeEnd("[DuckDB] バンドル選択");
  console.time("[DuckDB] Worker作成");
  const worker = new Worker(bundle.mainWorker!);
  console.timeEnd("[DuckDB] Worker作成");
  console.time("[DuckDB] WASM instantiate");
  const logger = new duckdb.ConsoleLogger();
  const db = new duckdb.AsyncDuckDB(logger, worker);
  await db.instantiate(bundle.mainModule, bundle.pthreadWorker);
  console.timeEnd("[DuckDB] WASM instantiate");
  console.timeEnd("[DuckDB] 初期化合計");
  return db;
})();

export const initDuckDB = (): Promise<duckdb.AsyncDuckDB> => initPromise;
